import { useEffect, useState } from "react";
import { ArrowLeft, Box, Code2, FileText, FolderArchive, Globe, Image as ImageIcon, Loader2, Search, Shapes } from "lucide-react";
import { vai, errorText } from "@/lib/vai";
import { KIND_LABELS } from "@/components/vai/artifacts";

// Page Artefacts (barre latérale) : tout ce que l'IA a créé dans les conversations
// (projets .zip, pages web, scripts, scènes 3D…), avec recherche. Un clic rouvre la
// conversation avec l'artefact ouvert.

const ICONS = { project: FolderArchive, html: Globe, react: Code2, code: Code2, svg: ImageIcon, three: Box, markdown: FileText, mermaid: Shapes };

export default function ArtifactsPage({ onBack, onOpen }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  const [q, setQ] = useState("");
  useEffect(() => {
    const t = setTimeout(() => vai.get("/artifacts", { q }).then((r) => setItems(r.artifacts)).catch((err) => setError(errorText(err))), q ? 300 : 0);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="flex-1 overflow-y-auto" data-testid="vai-artifacts-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <button type="button" onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-white/50 hover:text-white mb-6"><ArrowLeft className="w-4 h-4" />Retour</button>
        <h1 className="text-2xl font-semibold tracking-tight">Artefacts</h1>
        <p className="text-sm text-white/55 mt-1">Tout ce que Vanta AI a créé pour toi : projets à télécharger en .zip, pages web, scripts, scènes 3D…</p>
        <div className="relative mt-5">
          <Search className="w-4 h-4 absolute left-3 top-3 text-white/35" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un artefact ou une conversation…"
            className="w-full rounded-xl bg-white/[0.04] border border-white/10 pl-9 pr-3 py-2.5 text-sm outline-none focus:border-white/25" data-testid="vai-artifacts-search" />
        </div>
        {error ? <p className="mt-6 text-sm text-red-300">{error}</p> : items === null ? (
          <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-white/40" /></div>
        ) : items.length === 0 ? (
          <div className="mt-12 text-center">
            <Shapes className="w-8 h-8 mx-auto text-white/20" />
            <p className="mt-3 text-sm text-white/45">{q ? "Aucun résultat." : "Pas encore d'artefact. Demande une page web, un script FiveM en .zip ou une scène 3D."}</p>
          </div>
        ) : (
          <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {items.map((a) => {
              const Icon = ICONS[a.type] || Code2;
              return (
                <button key={`${a.chat_id}-${a.id}`} type="button" onClick={() => onOpen(a)} data-testid="vai-artifact-item"
                  className="text-left rounded-xl border border-white/[0.08] bg-white/[0.02] p-4 hover:bg-white/[0.05] hover:border-white/15 transition-colors">
                  <span className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center"><Icon className="w-4 h-4 text-sky-300" /></span>
                  <p className="mt-3 text-sm font-medium truncate">{a.title}</p>
                  <p className="text-[11px] text-white/45 mt-0.5">{KIND_LABELS[a.type] || "Code"}{a.versions > 1 ? ` · ${a.versions} versions` : ""}</p>
                  <p className="text-[11px] text-white/30 mt-2 truncate">{a.chat_title} · {new Date(a.updated_at).toLocaleDateString("fr-FR", { day: "numeric", month: "short" })}</p>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
